// @ts-ignore
import type * as SchemaTypes from '../../../../index';

import { gql } from 'graphql-tag';
import { FacetedContentProductLabelTranslationFragmentDoc } from '../../../../../../domain/product/useFacetedContent.generated';
export const FilterEngagementRingDesignFeatureFragmentDoc = gql`
    fragment filterEngagementRingDesignFeature on CatalogueFilterEngagementRingDesignFeatureItem {
  __typename
  label {
    systemCode
    translation(locale: $locale) {
      name
      ...facetedContentProductLabelTranslation
    }
    icon {
      __typename
      id
      url
    }
  }
  totalResults
}
    ${FacetedContentProductLabelTranslationFragmentDoc}`;